import { path } from 'ramda';

export const statusSections = {
  narcomsMobility: 7,
  narcomsHandFunction: 6,
  narcomsVision: 6,
  narcomsFatigue: 6,
  narcomsCognition: 6,
  narcomsBladderBowel: 6,
  narcomsSexuality: 0,
  narcomsSensory: 6,
  narcomsSpasticity: 6,
  narcomsPain: 6,
  narcomsDepression: 6,
  narcomsTremor: 6,
  speechDysfagia: 6,
};

export const predssSections = {
  prEDSS: 10,
};

export const historyViewFields = Object.keys(statusSections);
export const historyDashFields = [
  'narcomsMobilityVASValue',
  'narcomsSensoryVASValue',
  'narcomsHandFunctionVASValue',
  'narcomsSpasticityVASValue',
  'narcomsVisionVASValue',
  'narcomsPainVASValue',
  'narcomsFatigueVASValue',
  'narcomsDepressionVASValue',
  'narcomsCognitionVASValue',
  'narcomsTremorVASValue',
  'narcomsBladderBowelVASValue',
  'narcomsSexualityVASValue',
  'speechDysfagiaVASValue',
];
export const historyViewLegacyFields = [
  'ambulatory',
  'muscular',
  'balance',
  'hearingSpeakingSwallowing',
  'senseOfTouch',
  'bowelAndBladder',
  'vision',
  'fatigueAndCognition',
];

export const isLegacyDocument = doc => path(['sections', 'ambulatory'], doc);

export const questionnaireNames = { narcomsCognition: 'msnq', narcomsFatigue: 'fsmc' };

export const getAutoScrollOffset = nextSection => {
  if (nextSection === 'narcomsMobility') return 100;
  return 250;
};
